import { useEffect } from 'react'
import { APPID, AgentID } from '@/config/config'

const Wechat = () => {
  useEffect(() => {
    (window as any).WwLogin({
      'id': 'wx_login',
      'appid': APPID,// appid
      'agentid': AgentID,// agentid
      'redirect_uri': window.location.origin.replace(/\/$/, '') + '/qrlogin',// 回调地址，注意回调地址需要进行urlencode
      'state': '',// 用于保持请求和回调的状态，授权请求后原样带回给企业。该参数可用于防止csrf攻击,参数非必填
      'href': '',// 自定义样式链接，企业可根据实际需求覆盖默认样式，参数非必填
    });
  }, [])

  return (
    <div>
      <div className='mt-20' id='wx_login' style={{ textAlign: 'center' }} />
    </div>
  )
}

export default Wechat
